"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formik_1 = require("formik");
const dynamic_1 = __importDefault(require("next/dynamic"));
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_error_message_1 = require("@hotelplan/components.common.error-message");
const libs_validation_1 = require("@hotelplan/libs.validation");
const DOBInput_skeleton_1 = __importDefault(require("./DOBInput.skeleton"));
const DOBInput = (0, dynamic_1.default)(() => Promise.resolve().then(() => __importStar(require('./DOBInput'))), {
    ssr: false,
    loading() {
        return react_1.default.createElement(DOBInput_skeleton_1.default, null);
    },
});
const StatusDOBInput = (0, styled_components_1.default)(props => react_1.default.createElement(DOBInput, Object.assign({}, props)))(({ success, theme }) => (success ? theme.inputs.success : {}), ({ error, theme }) => (error ? theme.inputs.error : {}));
const ValidatedDOBInput = props => {
    const [field, meta, helpers] = (0, formik_1.useField)({ name: props.name });
    const [t] = (0, react_i18next_1.useTranslation)();
    let icon = props.icon;
    const inputState = (0, libs_validation_1.getValidatedFieldState)(meta.error, meta.touched);
    switch (inputState) {
        case libs_validation_1.FieldState.Error:
            icon = { name: 'warning-outlined' };
            break;
        case libs_validation_1.FieldState.Success:
            icon = { name: 'success' };
            break;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StatusDOBInput, Object.assign({}, props, { success: inputState === libs_validation_1.FieldState.Success, error: inputState === libs_validation_1.FieldState.Error, value: field.value, onChange: (nextValue) => {
                helpers.setValue(nextValue);
                helpers.setTouched(true);
            }, onBlur: (_, e) => {
                field.onBlur(e);
            }, icon: icon, hideLabel: false })),
        props.showErrorMessage && inputState === libs_validation_1.FieldState.Error && (react_1.default.createElement(components_common_error_message_1.ErrorMessage, { getMessage: message => t(message), error: meta.error }))));
};
exports.default = ValidatedDOBInput;
//# sourceMappingURL=ValidatedDOBInput.js.map